export const URL_SEPARATOR = '/';
export const HOME_BREADCRUMB_NAME = 'Home';
export const HOME_BREADCRUMB_URL = '/';
